import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import i18next from "i18next";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import paramRender from "@mnjsplatform/components/lib/common/ParamRenderUniversal";
import {ActionType, DocumentTypeEnum, getDocumentTypeAction, getDocumentTypeActions} from "./DocumentTypes";
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";

class OldPrivateDocument extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isDataReady: false,
            uploadVisible: false,
            actionId: null
        }
    }

    componentDidMount() {
        this.setState({isDataReady: false}, this.initialize);
    }

    getDataItem = (documentTypeId) => {
        switch (documentTypeId) {
            case DocumentTypeEnum.Passport:
                return this.props.Documents_ListDocCivilForPONew;
            case DocumentTypeEnum.Numbers:
                return this.props.Documents_ListDocNumPersForPONew;
            case DocumentTypeEnum.Military:
                return this.props.Documents_ListDocMilitaryForPONew;
            case DocumentTypeEnum.Driver:
                return this.props.Documents_ListDocDriveForPONew;
            case DocumentTypeEnum.PassportInternational:
                return this.props.Documents_ListDocInternationalForPONew;
            case DocumentTypeEnum.Pension:
                return this.props.Documents_ListDocPensCertForPONew;
            case DocumentTypeEnum.ResidencePermit:
                return this.props.Documents_ListDocResPermitForPONew;
            case DocumentTypeEnum.AddressOfficial:
                return this.props.OfficialAddress_ListDocForPONew;
            case DocumentTypeEnum.AddressFact:
                return this.props.FactAddress_ListDocForPONew;
            case DocumentTypeEnum.HealthInsurance:
                return this.props.PersMedInsure_ListDocForPONew;
            default: {
                return null;
            }
        }
    };

    initialize = async () => {
        try {
            try {
                const dataItem = this.getDataItem(this.props.row.ClaimPDTypeId);
                if (dataItem) {
                    await this.props.dispatch(dataItem.reset());
                    await this.props.dispatch(dataItem.execute({}, {
                        withParams: false,
                        withStyle: true,
                        newItem: true
                    }));
                }
            } catch (e) {
                console.error(e);
            }
        } finally {
            this.setState({isDataReady: true})
        }
    }
    renderActions = (row) => {
        let actions = getDocumentTypeActions(row.ClaimPDTypeId, this.props.appParams);
        return actions && actions.length > 0 && actions.map((action, index) => {
            return <button className="btn btn-regular -goahead" type="button" title={i18next.t(action.DisplayName)}
                    key={action.ActionId}
                    onClick={() => {
                        if (action.ActionType === ActionType.Link) {
                            window.open(action.Url, "_blank");
                        } else {
                            this.uploadDocument(action.ActionId)
                        }
                    }}>
                <i className="search zmdi zmdi-accounts-add" style={{}}/>&nbsp;{i18next.t(action.DisplayName)}
            </button>});
    }

    render() {
        let control;
        const dataItem = this.getDataItem(this.props.row.ClaimPDTypeId);
        const actionInfo = getDocumentTypeAction(this.state.actionId);
        if (!dataItem)
            return null;
        if (dataItem.rowsCount() === 0) {
            control = <div className="text-muted mb-2">{i18next.t("Data_Not_Found_1")}</div>;
        } else {
            control = this.props.row.IsXGrid === 1
                ? <GridView dataItem={dataItem} useItemStyle={true}/>
                : <ComplexParam dataItem={dataItem} readOnly={true} showApplyButton={false}
                                showSearchBar={false} renderParams={paramRender}/>
        }
        /*control =
                <>
                    {control}
                    <RequestHistory rowKey={{ClaimPDTypeId: this.props.row.ClaimPDTypeId}} updateStateFlag={this.state.updateStateFlag}/>
                </>;*/
        return (
            <PlaceholderWrapper placeholderId={this.props.row.ClaimPDTypeId} showSplitterLine={false}
                                key={this.props.row.ClaimPDTypeId}
                                canCollapse={true} collapsed={true}
                                title={<><i className='fa fa-file-code-o'/> {this.props.row.ClaimPDTypeName}</>}
            >

                <div className="ml-2">
                    {
                        this.state.isDataReady
                            ? control
                            : i18next.t('LoadingLabel')
                    }
                </div>
                {this.renderActions(this.props.row)}
                {this.state.uploadVisible && actionInfo &&
                    actionInfo.Action(
                        {
                            documentType: actionInfo,
                            onClose: () => this.setState({uploadVisible: false, actionId: null})
                        })
                }
            </PlaceholderWrapper>
        );
    }

    uploadDocument = async (actionId) => {
        try {
            let actionInfo = getDocumentTypeAction(actionId);
            if (actionInfo?.ConfirmationText) {
                if (await confirm(i18next.t(actionInfo.ConfirmationText), {header: i18next.t("Confirmation")})) {
                    this.setState({uploadVisible: true, actionId: actionId});
                }
            }
        } catch (e) {
        }
    }
}

OldPrivateDocument.propTypes = {
    dispatch: PropTypes.func.isRequired,
    row: PropTypes.object,
    headerAllowAdd: PropTypes.string
}

OldPrivateDocument.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        Documents_ListTypeDocForPO: state.privateDocumentsState.Documents_ListTypeDocForPO,
        Documents_ListDocCivilForPONew: state.privateDocumentsState.Documents_ListDocCivilForPONew,
        Documents_ListDocNumPersForPONew: state.privateDocumentsState.Documents_ListDocNumPersForPONew,
        Documents_ListDocMilitaryForPONew: state.privateDocumentsState.Documents_ListDocMilitaryForPONew,
        Documents_ListDocDriveForPONew: state.privateDocumentsState.Documents_ListDocDriveForPONew,
        Documents_ListDocInternationalForPONew: state.privateDocumentsState.Documents_ListDocInternationalForPONew,
        Documents_ListDocPensCertForPONew: state.privateDocumentsState.Documents_ListDocPensCertForPONew,
        Documents_ListDocResPermitForPONew: state.privateDocumentsState.Documents_ListDocResPermitForPONew,
        OfficialAddress_ListDocForPONew: state.privateDocumentsState.OfficialAddress_ListDocForPONew,
        FactAddress_ListDocForPONew: state.privateDocumentsState.FactAddress_ListDocForPONew,
        PersMedInsure_ListDocForPONew: state.privateDocumentsState.PersMedInsure_ListDocForPONew,
        appParams: state.appState.appParams
    }
}

export default connect(mapStateToProps)(OldPrivateDocument);